module.exports = __webpack_public_path__ + "img/t5-c6.44356c40.png";